import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Box, Checkbox, Stack, Typography} from '@mui/material';
import {useEffect, useRef, useState} from 'react';
import axios from 'axios';
import {useSelector} from 'react-redux';
import {constance} from "../../common/constance/constance";
import {RootState} from "../../reducer";
import {common} from "../../common/common";

const sha256 = require('sha256');

/* 도서지원 페이지 알람 */
export default function BookApplicationDialog(props: { open: boolean, setOpen: any, saveBookApplication: any }) {
    console.log('[BookApplicationDialog]');

    const [state, setState] = useState({
        checked: false,
    })

    const handleClose = () => {
        props.setOpen(false)
    };

    function handleCheckBox(e: React.ChangeEvent<HTMLInputElement>) {
        setState({
            ...state,
            checked: Boolean(e.target.value)
        })
    }

    function saveBookApplication() {
        props.setOpen(false)
        props.saveBookApplication();
    }

    return (
        <Box sx={{}}>
            <Dialog open={props.open} onClose={handleClose} sx={{maxHeight: '100vh',}}>
                {/*<DialogTitle>*/}
                {/*</DialogTitle>*/}
                <DialogContent sx={{backgroundImage: 'url(/images/book-application-background.png)'}}>
                    <DialogContentText>
                        <Typography variant={'h4'} align={'center'}
                                    sx={{color: '#fff', letterSpacing: '8px'}}>도서지원규정</Typography>
                        <Stack sx={{mt: 2, backgroundColor: 'var(--scc-surface)', p: 2, borderRadius: 2}}>
                            <Typography variant={'h6'} sx={{mb: 2}}>
                                {`1. 도서신청 가능 권 수 : 1인당 1년에 6권 지원`}
                            </Typography>
                            <Typography variant={'h6'} sx={{mb: 1}}>
                                {`2. 신청 불가능 도서`}
                            </Typography>
                            <Typography variant={'h6'} sx={{mb: 0, ml: 2, color: '#fc0000'}}>
                                {`- 일반 소설 (로맨스 소설 등)`}
                            </Typography>
                            <Typography variant={'h6'} sx={{mb: 0, ml: 2, color: '#fc0000'}}>
                                {`- 특정분야에서의 기술서 (엑셀, 용어 사전 등)`}
                            </Typography>
                            <Typography variant={'h6'} sx={{mb: 0, ml: 2, color: '#fc0000'}}>
                                {`- 잡지, 정기기간행물 등`}
                            </Typography>
                            <Typography variant={'h6'} sx={{mb: 0, ml: 2, color: '#fc0000'}}>
                                {`- 웹툰/만화책`}
                            </Typography>
                            <Typography variant={'h6'} sx={{mb: 0, ml: 2, color: '#fc0000'}}>
                                {`- 개인 취미 생활을 위한 서적`}
                            </Typography>
                            <Typography variant={'h6'} sx={{mb: 2, ml: 2, color: '#fc0000'}}>
                                {`- 육아서적`}
                            </Typography>

                            <Typography variant={'h6'} sx={{mb: 2}}>
                                {`3. 지원도서 반납기간 : 수령 후 2개월 이내`}
                            </Typography>

                            <Box sx={{display: 'flex'}}>
                                <Typography variant={'h6'} sx={{mb: 2}}>
                                    {`4. 지원도서 반납처 : `}
                                </Typography>
                                <Typography variant={'h6'} sx={{mb: 2, ml: 1, color: '#fc0000'}}>
                                    {`총무팀에 직접 반납`}
                                </Typography>
                            </Box>

                        </Stack>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Box sx={{display: 'flex', alignItems: 'center', width: 1, justifyContent: 'flex-end'}}>
                        <Typography>위 내용을 확인하였습니다. </Typography>
                        <Checkbox value={state.checked}
                                  onChange={(e) => handleCheckBox(e)}/>
                        <Button variant={"contained"} color={'error'} sx={{ml: 3, mr: 1}}
                                onClick={handleClose}>취소</Button>
                        <Button disabled={!state.checked} variant={"contained"} color={'neutral'}
                                onClick={saveBookApplication}>신청하기</Button>
                    </Box>

                </DialogActions>
            </Dialog>
        </Box>
    );
}